import React from 'react';

const KlassiBrand = ({ className = '' }) => (
  <span className={`klassi-brand ${className}`.trim()}>
    Klassi<sup className="klassi-tm" aria-label="trademark">™</sup>
  </span>
);

export default KlassiBrand;
